<template>
  <div class="container-fluid mb-4" v-if="currentMeal != null">
    <div class="row">
      <div class="col-12">
        <h2> {{ currentMeal.name }} </h2>
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        <label class="block text-nowrap text-truncate"> Precio (Inc. IGV) </label>
        <el-input type="number" :value="currentMeal.price" @input="changePrice"></el-input>
      </div>
      <div class="col-4">
        <label class="block text-nowrap text-truncate"> Precio Sugerido </label>
        <el-input v-model="currentMeal.proposed_price" disabled></el-input>
      </div>
      <div class="col-4">
        <label class="block text-nowrap text-truncate"> Precio de comparación </label>
        <el-input v-model="currentMeal.comparison_price" disabled></el-input>
      </div>
    </div>
    <br v-if="currentMeal.sections.length > 0">
    <template v-for="(section, index) in currentMeal.sections">
      <el-collapse>
        <el-collapse-item title="Consistency" :name="section.id">
          <template slot="title">
            <h4> {{ section.title }} </h4>
          </template>
          <form>
            <div class="form-group">
              <label class="" for="nombreGeneral"> Nombre General </label>
              <el-input v-model="section.general_description" disabled id="nombreGeneral"></el-input>
            </div>
            <div class="form-group">
              <label class="" for="descripcionApp"> Descripcion en App</label>
              <el-input v-model="section.description" disabled id="descripcionApp"></el-input>
            </div>
            <div class="d-flex">
              <div class="form-group mr-4">
                <label for="minimo">Minimo: </label>
                <el-input v-model="section.min_quantity" disabled id="minimo"></el-input>
              </div>
              <div class="form-group">
                <label for="maximo">Maximo: </label>
                <el-input v-model="section.max_quantity" disabled id="maximo"></el-input>
              </div>
            </div>
            <div class="form-group mr-4">
              <el-checkbox :value="section.is_mandatory == 1">Obligatorio</el-checkbox>
            </div>
          </form>
          <div class="card">
            <el-table :data="section.options">
              <el-table-column prop="name" label="Opciones" min-width="120">
              </el-table-column>
              <el-table-column prop="price" label="Precio" min-width="100" :formatter="priceFormatter">
              </el-table-column>
              <el-table-column prop="status" label="Estado" width="100px">
                <template v-slot="{ row }">
                  <el-switch :value="row.status" @change="changeOptionStatus(row)" active-color="#13ce66"
                    inactive-color="#e9ecef" :active-value="1" :inactive-value="0">
                  </el-switch>
                </template>
              </el-table-column>
              <el-table-column label="Obligatorio" prop="is_mandatory" min-width="130">
                <template v-slot="{ row }">
                  <el-checkbox :value="row.is_mandatory == 1" text-color="#e9ecef">
                    No aplica</el-checkbox>
                </template>
              </el-table-column>
              <el-table-column label="Receta" prop="meal_id" min-width="130">
                <template v-slot="{ row }">
                  <a v-if="row.meal_id" target="_blank" :href="'/#/foodcourt/receta/'+row.meal_id">
                    <base-button type="success" class="btn-sm">Ver Receta</base-button>
                  </a>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-collapse-item>
      </el-collapse>
    </template>
    <div class="row mt-4">
      <div class="col-12">
        <button type="button" class="btn btn-primary block" :disabled="pristine || loading"
          @click="submit">GUARDAR</button>
      </div>
    </div>
  </div>
</template>
<script>

import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import StatsCard from "@/components/Cards/StatsCard";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import BackofficeApi from "../../gateways/backoffice-api";
import CustomModal from "../../components/CustomModal";

import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Collapse,
  CollapseItem,
  Switch,
  Checkbox,
} from "element-ui";

export default {
  name: "starter-page",
  props: {
    meal: {
      type: Object, // Specify the type of the prop
      required: false // If the prop is required or not
    }
  },
  components: {
    StatsCard,
    RouteBreadCrumb,
    flatPicker,
    CustomModal,
    [Checkbox.name]: Checkbox,
    [Switch.name]: Switch,
    [CollapseItem.name]: CollapseItem,
    [Collapse.name]: Collapse,
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
  },
  data() {
    return {
      loading: false,
      pristine: true,
      currentMeal: null,
      checked: true,
    };
  },
  mounted() {
  },
  computed: {
    host() {
      return process.env.VUE_APP_API_BACKOFFICE_URL.replace("/api/v1/", "");
    },
  },
  watch: {
    meal: {
      handler: function (newVal, oldVal) {
        if (newVal) {
          this.currentMeal = structuredClone(newVal);
        } else {
          this.currentMeal = null;
        }
      },
      deep: true,
    },
  },
  methods: {
    changePrice(value) {
      this.currentMeal.price = value;
      this.pristine = false;
    },
    changeOptionStatus(option) {
      option.status = option.status == 1 ? 0 : 1;
      this.pristine = false;
    },
    priceFormatter(row, column) {
      if (row.price > 0) {
        return row.price;
      }
    },
    async submit() {
      this.loading = true;
      const response = await BackofficeApi.put(
        this.host + '/api/v3/restaurants/meals/' + this.currentMeal.id,
        this.currentMeal,
      );
      if (response["data"]["success"]) {
        this.$emit('onMealChange', this.currentMeal);
        this.$emit('closeModal');
        this.pristine = true;
      }
      this.loading = false;
    },
  },
};
</script>
<style lang="scss">
.card {
  box-shadow: none !important;
}

.weight {
  width: 30%;
  border: 1px solid black;

  td,
  th,
  tr {
    border: 1px solid black;
  }
}
</style>
<style>
.form-group {
  margin-bottom: 1rem !important;
}

.noMargin {
  margin-bottom: 0rem;
}

.starter-page {
  min-height: calc(100vh - 380px);
}

.recipe img {
  max-width: 100%;
}

p {
  white-space: pre-line
}

@media screen {
  #print {
    display: none;
  }
}

@media print {
  body * {
    visibility: hidden;
  }

  #print,
  #print * {
    visibility: visible;
  }

  #print {
    position: absolute;
    left: 0;
    top: 0;
  }
}

@media all and (max-width:480px) {
  .block-sm {
    width: 100%;
    display: block;
  }
}
</style>
